<div class="card overflow-auto flex flex-col md:flex-row sm:mr-6">
  <div class="p-6 flex-auto">
    <h3 class="body-2 m-0 mb-2 text-gray-500 uppercase tracking-wide">Herramientas IA</h3>

    <div class="mt-4 grid grid-cols-3 gap-2">
      <ng-container *ngFor="let feature of features">
        <!-- External URL -->
        <a
          *ngIf="feature.url"
          [href]="feature.url"
          target="_blank"
          rel="noopener noreferrer"
          (click)="close()"
          class="text-dark p-4 text-center hover:bg-primary-600/10 hover:text-primary-600 transition duration-400 ease-out-swift rounded-lg block no-underline">
          <mat-icon [svgIcon]="feature.icon" class="icon-xl" color="primary"></mat-icon>
          <div class="body-2 mt-2 font-semibold flex items-center justify-center gap-1">
            {{ feature.label }}
            <mat-icon svgIcon="mat:open_in_new" class="!w-4 !h-4 !text-base text-gray-400"></mat-icon>
          </div>
        </a>

        <!-- Internal route -->
        <a
          *ngIf="feature.route && !feature.url"
          [routerLink]="feature.route"
          (click)="close()"
          class="text-dark p-4 text-center hover:bg-primary-600/10 hover:text-primary-600 transition duration-400 ease-out-swift rounded-lg block no-underline">
          <mat-icon [svgIcon]="feature.icon" class="icon-xl" color="primary"></mat-icon>
          <div class="body-2 mt-2 font-semibold">{{ feature.label }}</div>
        </a>
      </ng-container>
    </div>
  </div>
</div>
